var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 3.66675C9.66667 2.74627 8.92047 2.00008 8 2.00008C7.07953 2.00008 6.33333 2.74627 6.33333 3.66675C6.33333 4.58722 7.07953 5.33342 8 5.33342C8.92047 5.33342 9.66667 4.58722 9.66667 3.66675ZM11 3.66675C11 5.3236 9.65685 6.66675 8 6.66675C6.34315 6.66675 5 5.3236 5 3.66675C5 2.00989 6.34315 0.666748 8 0.666748C9.65685 0.666748 11 2.00989 11 3.66675Z",
    fill: "#9BA4AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 13.6667C0.664062 10.2812 3.72488 7.66675 7.33073 7.66675C7.69892 7.66675 7.9974 7.96522 7.9974 8.33341C7.9974 8.7016 7.69892 9.00008 7.33073 9.00008C4.30925 9.00008 1.9974 11.1609 1.9974 13.6667C1.9974 14.0349 1.69892 14.3334 1.33073 14.3334C0.962539 14.3334 0.664062 14.0349 0.664062 13.6667Z",
    fill: "#9BA4AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6641 11.3334C13.6641 10.0448 12.6194 9.00008 11.3307 9.00008C10.0421 9.00008 8.9974 10.0448 8.9974 11.3334C8.9974 12.6221 10.0421 13.6667 11.3307 13.6667C12.6194 13.6667 13.6641 12.6221 13.6641 11.3334ZM14.9974 11.3334C14.9974 13.3585 13.3558 15.0001 11.3307 15.0001C9.30569 15.0001 7.66406 13.3585 7.66406 11.3334C7.66406 9.30837 9.30569 7.66675 11.3307 7.66675C13.3558 7.66675 14.9974 9.30837 14.9974 11.3334Z",
    fill: "#9BA4AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3281 10.3334C10.3281 9.96522 10.6266 9.66675 10.9948 9.66675C11.363 9.66675 11.6615 9.96522 11.6615 10.3334V11.0001H12.3281C12.6963 11.0001 12.9948 11.2986 12.9948 11.6667C12.9948 12.0349 12.6963 12.3334 12.3281 12.3334H10.9948C10.6266 12.3334 10.3281 12.0349 10.3281 11.6667V10.3334Z",
    fill: "#9BA4AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitsIcon);
export default __webpack_public_path__ + "static/media/visits-icon.bc8b8577a838d690e5f616287961ebcc.svg";
export { ForwardRef as ReactComponent };